import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../../api/client";
import Card from "../../components/ui/Card";
import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import Select from "../../components/ui/Select";

const STEPS = ["Personal info","Contact details","Set password"];

export default function SignupPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({ firstName:"", lastName:"", otherNames:"", dateOfBirth:"", gender:"", email:"", phone:"", password:"", confirmPw:"" });
  const [err,  setErr]  = useState("");
  const [errFirstName,  setFirstNameErr]  = useState("");
  const [errLastName,  setLastNameErr]  = useState("");
  const [erremail, setEmailErr] = useState("");
  const [errphone, setPhoneError] = useState("");
  const [errgender, setGenderErr] = useState("");

  const set = (k: string) => (v: string) => setForm(f => ({ ...f, [k]:v }));

  const next = async () => {
    if (step < 2) {
      if (form.firstName==""){
        setFirstNameErr("First name is required!");
      }
      else if (form.lastName==""){
        setLastNameErr("Last name is required!");
      }
      else{
        if (step === 1){
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const phoneRegex = /^\+?[0-9\s\-()]{7,15}$/;
          // if (!emailRegex.test(form.email)){
          //   //setEmailErr("Invalid email address!");
          //   //return;
          // }
          if(!phoneRegex.test(form.phone)){
            setPhoneError("Invalid phone number. (eg. 080 0000 0000)");
            return;
          }
          else if(form.gender===""){
            setGenderErr("Please select gender!");
          }
          else{
            setStep(s => s+1);
          }
        }
        else{
          setStep(s => s+1);
        }        
      }      
      return; 
    }
    
    try {
      const cleanedPhone = form.phone.replace(/(?!^\+)\D/g, "");
      const { token } = await api.post("/auth/signup", {
        firstName: form.firstName, lastName: form.lastName,
        email: form.email, phone: cleanedPhone, password: form.password,
        otherNames: form.otherNames, dateOfBirth:form.dateOfBirth, gender: form.gender,
      }) as any;
      localStorage.setItem("token", token);
      navigate("/kyc");
    //} catch(e: any) { console.log(e); setErr(e?.error || "Signup failed"); }
    } catch(e: any) { console.log(e); setErr(e?.errors[0].msg +" -> "+e?.errors[0].path || "Signup failed"); }
  };

  const previous = () =>{setStep(s => (s-1));};

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-7">
          <img src="/heritage.jpg" width="45" height="40" className="mx-auto block" style={{borderRadius:"7px"}} alt="logo" />
          <h1 className="text-xl font-medium text-white mt-2">Create your account</h1>
        </div>
        <div className="flex gap-1.5 mb-5">
          {STEPS.map((_, i) => (
            <div key={i} className="flex-1 h-1 rounded-full transition-all duration-300"
              style={{ background: i <= step ? "#059669" : "#475569" }}/>
          ))}
        </div>        
        <Card>
          <h2 className="text-base font-medium text-slate-700 mb-5">Step {step+1}: {STEPS[step]}</h2>
          {err && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">{err}</div>}
          {step===0 && <>
            <Input label="First name" value={form.firstName} onChange={set("firstName")} placeholder="Jordan" error={errFirstName} required />
            <Input label="Last name"  value={form.lastName}  onChange={set("lastName")}  placeholder="Mensah" error={errLastName} required/>
            <Input label="Other name(s)"  value={form.otherNames}  onChange={set("otherNames")}  placeholder="Joe Clark"/>
          </>}
          {step===1 && <>
            <Input label="Phone" type="tel" value={form.phone} onChange={set("phone")} placeholder="080 0000 0000"  error={errphone} />
            <Input label="Email" type="email" value={form.email} onChange={set("email")} placeholder="jordan@example.com" error={erremail} />            
            <Input label="Date of Birth" type="date" value={form.dateOfBirth} onChange={set("dateOfBirth")} placeholder="12/02/2000"/>
            <Select label="Gender" value={form.gender} onChange={set("gender")} options={[{value:"",label:"Select gender"},{value:"male", label:"Male"},{value:"female", label:"Female"}]} error={errgender} />
            <Button onClick={previous} size="lg" className="w-full justify-center clearance btn_bkgrd">{"<< Back"}</Button>
          </>}
          {step===2 && <>
            <Input label="Password" type="password" value={form.password}   onChange={set("password")}   placeholder="Min 8 characters"/>
            <Input label="Confirm password" type="password" value={form.confirmPw} onChange={set("confirmPw")}
              error={form.confirmPw && form.password !== form.confirmPw ? "Passwords don't match" : null}/>
              <Button onClick={previous} size="lg" className="w-full justify-center clearance btn_bkgrd">{"<< Back"}</Button>
          </>}
          <Button onClick={next} size="lg" className="w-full justify-center">
            {step < 2 ? "Continue →" : "Create Account"}
          </Button>
          <p className="text-center text-sm text-slate-500 mt-3">
            Already have an account? <Link to="/login" className="text-emerald-600 font-medium">Sign in</Link>
          </p>
        </Card>
      </div>
    </div>
  );
}